import { create } from 'zustand'

export const useUserStore = create((set) => ({
    userInfo: {},
    propFacilities:{},
    locationId:"",
    locationName: "",
    appVersion:"1.0.3",
    setLocationId: (newLocationId) => set((state) => ({ locationId: newLocationId })),
    setAppVersion: (newAppVersion) => set((state) => ({ appVersion: newAppVersion })),
    setLocationName: (newLocationName) => set((state) => ({ locationName: newLocationName })),
    // setUserInfo: (newUserInfo) => set((state) => {...state, userInfo: newUserInfo }),
    setUserInfo: (newUserInfo) => set((state) => {
        console.log("newUserInfo", {...state, userInfo: newUserInfo })
        
         return {...state, userInfo: newUserInfo }
    }),
    setPropFacilities: (newPropFacilities) => set((state) => {
        console.log("newPropFacilities", {...state, propFacilities: newPropFacilities })
        
         return {...state, propFacilities: newPropFacilities }
    }),
    accessToken: '',
    setToken: (newToken) => set((state) => ({ accessToken: newToken })),
}))